import { PracticeFormQuestion } from "@physiofit-digital/physiofit_types";
import { InfoText } from "../../../core/components/texts/InfoText";
import { getCurrentCostBearerScreenStep } from "../../../core/store/currentFormSlice";
import { useMainStore } from "../../../core/store/mainStore";
import { useLanguageSplitter } from "../../../core/translations/useLanguageSplitter";
import {
  readTextWithLineBreak,
  textWithLineBreakToArray,
} from "../../../core/utils/handleTextWithLineBreak";
import { FormAnswer } from "./FormAnswer";

type Props = {
  formQuestion: PracticeFormQuestion;
};

export const FormQuestion = ({ formQuestion }: Props) => {
  const languageSplitter = useLanguageSplitter();
  const currentQuestionIsCostBearer =
    formQuestion?.answer?.type === "costBearer";
  const currentCostBearerScreenStep = useMainStore(
    getCurrentCostBearerScreenStep,
  );
  if (!formQuestion) {
    return <div>No question available</div>;
  }

  const costBearerScreenTitle =
    currentCostBearerScreenStep === 0 || !currentCostBearerScreenStep
      ? "Heilbereich auswählen"
      : currentCostBearerScreenStep === 1
        ? "Kostenträger auswählen"
        : "Dokument unterschreiben";
  const costBearerScreenSubtitle =
    currentCostBearerScreenStep === 0
      ? "In welchem Bereich haben Sie heute Ihren ersten Termin?"
      : currentCostBearerScreenStep === 1
        ? "Über wen wird Ihr Rezept abgerechnet?"
        : "Bitte lesen Sie folgendes Dokument sorgfältig durch und unterschreiben Sie es im Anschluss.";

  const buildScaleLabelLines = () => {
    if (formQuestion.answer?.type !== "scale") {
      return [];
    }
    const scaleData = formQuestion.answer.scaleData;
    const lines: string[] = [];
    if (scaleData?.minLabel) {
      lines.push(`${scaleData.min ?? 0} = ${scaleData.minLabel}`);
    }
    if (scaleData?.maxLabel) {
      lines.push(`${scaleData.max ?? 10} = ${scaleData.maxLabel}`);
    }
    return lines;
  };

  const descriptionLines = textWithLineBreakToArray(
    readTextWithLineBreak(languageSplitter(formQuestion.description)),
  );
  const scaleLabelLines = buildScaleLabelLines();
  const questionSubtitles =
    scaleLabelLines.length > 0
      ? [
          ...descriptionLines.filter((line) => line !== ""),
          ...scaleLabelLines,
        ]
      : descriptionLines;

  return (
    <>
      <InfoText
        headline={
          currentQuestionIsCostBearer
            ? costBearerScreenTitle
            : languageSplitter(formQuestion.question)
        }
        subtitles={
          currentQuestionIsCostBearer
            ? [costBearerScreenSubtitle]
            : questionSubtitles
        }
      />

      <FormAnswer questionId={formQuestion.id} answer={formQuestion.answer} />
    </>
  );
};
